import { createSlice } from "@reduxjs/toolkit";
import { EmployeeInterface } from "../../common/interfaces/EmployeeInterface";

interface createDeactivateEmployeeConfirmationInterface {
    deactivatedEmployee?: EmployeeInterface;
    isDeactivateEmployeeConfirmationModalOpen?: boolean;
    isPatchDeactivateEmployeeSuccess: boolean;
    isPatchDeactivateEmployeeIsLoading: boolean;
}

const initialState: createDeactivateEmployeeConfirmationInterface = {
    isDeactivateEmployeeConfirmationModalOpen: false,
    isPatchDeactivateEmployeeSuccess: false,
    isPatchDeactivateEmployeeIsLoading: false,
};

const CreateDeactivateEmployeeConfirmationModalSlice = createSlice({
    name: "createDeactivateEmployeeConfirmation",
    initialState,
    reducers: {
        setIsDeactivateEmployeeConfirmationModalOpen: (state, action) => {
            state.isDeactivateEmployeeConfirmationModalOpen = action.payload;
        },
        setDeactivatedEmployee: (state, action) => {
            state.deactivatedEmployee = action.payload;
        },
        setIsPatchDeactivateEmployeeSuccess: (state, action) => {
            state.isPatchDeactivateEmployeeSuccess = action.payload;
        },
        setIsPatchDeactivateEmployeeIsLoading: (state, action) => {
            state.isPatchDeactivateEmployeeIsLoading = action.payload;
        },
    },
});

export const deactivateEmployeeConfirmationModalReducer =
    CreateDeactivateEmployeeConfirmationModalSlice.reducer;

export const {
    setIsDeactivateEmployeeConfirmationModalOpen,
    setDeactivatedEmployee,
    setIsPatchDeactivateEmployeeSuccess,
    setIsPatchDeactivateEmployeeIsLoading,
} = CreateDeactivateEmployeeConfirmationModalSlice.actions;
